import React from "react";

interface FieldListProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * A container component for grouping multiple FieldDisplay components with consistent spacing.
 */
export function FieldList({ children, className = "" }: FieldListProps) {
  return <div className={`space-y-3 mt-4 ${className}`}>{children}</div>;
}

